import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Eye, Download } from "lucide-react";
import { AppLayout } from "@/components/AppLayout";
import { viewProtected, downloadProtected } from "@/lib/files";
import api from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export default function Cuenta() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/agreement/status").then(({ data }) => setS(data)).catch(() => setS(false)); }, []);

  return (
    <AppLayout variant="firm">
      <h1 className="ddp-serif" style={{ fontSize: "clamp(28px,4vw,40px)", color: "var(--burgundy-dark)", margin: 0, letterSpacing: "-.02em" }}>Protección de datos</h1>
      <p style={{ color: "var(--muted)", fontSize: 15, marginTop: 8 }}>Estado del acuerdo de tratamiento de datos y confidencialidad de su despacho.</p>

      <div className="ddp-card" style={{ padding: 26, marginTop: 24 }} data-testid="account-dp">
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 16 }}>
          <ShieldCheck size={20} style={{ color: "var(--burgundy)" }} />
          <div className="ddp-serif" style={{ fontSize: 20, color: "var(--burgundy-dark)" }}>Acuerdo de tratamiento</div>
        </div>
        {s && s.accepted ? (
          <>
            <dl style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: "16px 24px", margin: 0 }}>
              {[["Estado", "Aceptado"], ["Versión", `${s.version} · ${s.date}`], ["Fecha de aceptación", fmt(s.accepted_at)], ["Representante", s.representative], ["Referencia electrónica", s.electronic_ref]].map(([l, v]) => (
                <div key={l}>
                  <dt style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: ".08em", color: "var(--muted)", fontWeight: 700, marginBottom: 5 }}>{l}</dt>
                  <dd style={{ margin: 0, fontSize: 14.5, color: "var(--ink)", overflowWrap: "anywhere" }}>{v || "—"}</dd>
                </div>
              ))}
            </dl>
            <div style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap" }}>
              <button onClick={() => viewProtected("/agreement/master").catch(() => toast.error("No se pudo abrir el acuerdo."))} data-testid="acc-view" className="ddp-btn ddp-btn-secondary ddp-btn-sm"><Eye size={15} /> Ver acuerdo</button>
              <button onClick={() => downloadProtected("/agreement/copy", `DDP_Acuerdo_${s.version}.pdf`).catch(() => toast.error("No se pudo descargar el justificante."))} data-testid="acc-download" className="ddp-btn ddp-btn-primary ddp-btn-sm"><Download size={15} /> Descargar justificante PDF</button>
            </div>
          </>
        ) : (
          <div style={{ fontSize: 14, color: "var(--muted)" }}>Aún no se ha formalizado el acuerdo de tratamiento.</div>
        )}
      </div>
    </AppLayout>
  );
}
